<script>
import Modal from '@/components/atoms/Modal'
import InputMap from '@/components/atoms/inputlib/components/InputMap'
import { Restaurants } from '@/api'

const INMMEDIATE_DISTANCE = 100
const ACCEPTABLE_DISTANCE = 200

export default {
    name: 'SpecifyLocation',
    components: { Modal, InputMap },
    model: {
        prop: 'address',
        event: 'change',
    },
    props: {
        address: {
            type: Object,
            default: () => {},
        },
        tooltip: String,
        height: {
            type: Number,
            default: undefined,
        },
        fullAddress: Boolean,
        loading: Boolean,
    },
    computed: {
        location: {
            get() {
                return {
                    latitude: this.address.latitude,
                    longitude: this.address.longitude,
                }
            },
            set(address) {
                this.$emit(
                    'change',
                    this.fullAddress
                        ? { ...this.address, ...address }
                        : {
                              ...this.address,
                              ...{
                                  latitude: address.latitude,
                                  longitude: address.longitude,
                              },
                          }
                )
                // this.$emit('next')
            },
        },
        original() {
            return {
                latitude: this.address.original_latitude,
                longitude: this.address.original_longitude,
            }
        },
        heightStyle() {
            return this.height ? `height: ${this.height}px` : undefined
        },
    },
    methods: {
        openWarning1() {
            this.$refs.waring1.openModal()
        },
        closeWarning1() {
            this.$refs.waring1.closeModal()
        },
        openWarning2() {
            this.$refs.waring2.openModal()
        },
        closeWarning2() {
            this.$refs.waring2.closeModal()
        },
        openWarning3() {
            this.$refs.waring3.openModal()
        },
        closeWarning3() {
            this.$refs.waring3.closeModal()
        },
        async verifyStep() {
            this.$emit('update:loading', true)
            if (!(await this.isInRange())) {
                this.openWarning3()
                this.$emit('update:loading', false)
                return
            }
            const distance = this.getDistance(this.original, this.address)
            if (distance > INMMEDIATE_DISTANCE && distance < ACCEPTABLE_DISTANCE) {
                this.openWarning1()
                this.$emit('update:loading', false)
                return
            } else if (distance >= ACCEPTABLE_DISTANCE) {
                this.openWarning2()
                this.$emit('update:loading', false)
                return
            }
            this.$emit('update:loading', false)
            this.$emit('next')
        },
        getDistance(p1, p2) {
            const R = 6.371 * 1000000 // Radius of the Earth
            const rlat1 = p1.latitude * (Math.PI / 180) // Convert degrees to radians
            const rlat2 = p2.latitude * (Math.PI / 180) // Convert degrees to radians
            const difflat = rlat2 - rlat1 // Radian difference (latitudes)
            const difflon = (p2.longitude - p1.longitude) * (Math.PI / 180) // Radian difference (longitudes)

            return (
                2 *
                R *
                Math.asin(
                    Math.sqrt(
                        Math.sin(difflat / 2) * Math.sin(difflat / 2) +
                            Math.cos(rlat1) *
                                Math.cos(rlat2) *
                                Math.sin(difflon / 2) *
                                Math.sin(difflon / 2)
                    )
                )
            )
        },
        async isInRange() {
            const resturants = new Restaurants()
            return await resturants.locationInRange(this.address?.latitude, this.address?.longitude)
        },
        async accept() {
            if (await this.isInRange()) {
                this.closeWarning1()
                this.$emit('next')
            } else {
                this.closeWarning1()
                this.openWarning3()
            }
        },
    },
}
</script>

<template lang="pug">
.d-flex.flex-column.pb-5(:style="heightStyle" :class="height ? 'mh-100' : 'h-100'")
    input-map.border-radius-sm.overflow-hidden(v-model="location" :map-zoom="19" :tooltip="tooltip" zoom draggable type-control height="100%")    
    modal(ref="waring1" :closable="false")
        template(v-slot:header)
            .modal-header-text {{ $t("details.address_warning.1.title") }}
        template(v-slot:body)
            p {{ $t("details.address_warning.1.text") }}
        template(v-slot:footer)
            button.btn.btn-secondary(@click="closeWarning1") {{ $t("details.address_warning.1.secondary_btn") }}
            button.btn.btn-primary(@click="accept") {{ $t("details.address_warning.1.primary_btn") }}
    modal(ref="waring2" :closable="false")    
        template(v-slot:header)
            .modal-header-text {{ $t("details.address_warning.2.title") }}
        template(v-slot:body)   
            p {{ $t("details.address_warning.2.text") }}
        template(v-slot:footer)
            button.btn.btn-primary(@click="closeWarning2") {{ $t("details.address_warning.3.primary_btn") }}
    modal(ref="waring3" :closable="false")    
        template(v-slot:header)
            .modal-header-text {{ $t("details.address_warning.3.title") }}
        template(v-slot:body)   
            p {{ $t("details.address_warning.3.text") }}
        template(v-slot:footer)
            button.btn.btn-primary(@click="closeWarning3") {{ $t("details.address_warning.3.primary_btn") }}
</template>
